import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";

import modalCSS from "src/app/components/modal/Modal.module.css";
import iconError from "src/assets/iconsGraphics/errorModal.svg";
import iconInfo from "src/assets/iconsGraphics/infoModal.svg";
import iconSuccess from "src/assets/iconsGraphics/successModal.svg";
import { HTTPCODES, ROUTES } from "src/config/constants";
import { AuthContext } from "src/contexts/AuthContext";
import { ApiResult } from "src/core/helpers/api/ApiResult";
import { IModalContent } from "src/types/global";

export const useModal = () => {
  const [active, setActive] = useState(false);
  const [content, setContent] = useState<IModalContent | undefined>();
  const authData = useContext(AuthContext);
  let history = useHistory();

  const triggerError = (result: ApiResult | null) => {
    if (!active) {
      if (result) {
        setContent(getContent(result));
        if (result.status && result.status === HTTPCODES.Unauthorized) {
          authData?.clearAuthData();
          history.push(ROUTES.home);
        }
      }
    }
  };

  const triggerSuccess = (result: any) => {
    if (!active) {
      result.status = HTTPCODES.Ok;
      setContent(getContent(result));
    }
  };

  useEffect(() => {
    if (content?.contentSet) {
      setActive(true);
    } else {
      setActive(false);
    }
  }, [content]);

  useEffect(() => {
    if (active) {
      setTimeout(close, 4000);
    }
  }, [active]);

  const close = () => {
    setContent(clearContent());
  };

  return { active, triggerError, triggerSuccess, content, close };
};

function clearContent() {
  let modalContent: IModalContent = {
    style: modalCSS.modalContent,
    icon: iconInfo,
    text: "",
    textStyle: "u-t-primary-dark",
    header: "Info",
    contentSet: false,
  };

  return modalContent;
}

function getContent(result: ApiResult | any | null) {
  let modalContent = {} as IModalContent;

  if (result && (!result.status || result.status !== HTTPCODES.Ok)) {
    modalContent.style = modalCSS.modalContentError;
    modalContent.icon = iconError;
    modalContent.textStyle = "u-t-error";
    modalContent.header = result?.body?.title ? result?.body?.title : "Greška";
    modalContent.text = !result.status ? "Došlo je do pogreške u sustavu. Molim vas kontaktirajte administratora." : result?.body?.message;
  } else if (result && result.status === HTTPCODES.Ok) {
    modalContent.style = modalCSS.modalContentSuccess;
    modalContent.icon = iconSuccess;
    modalContent.text = result.message;
    modalContent.textStyle = "u-t-success";
    modalContent.header = result.title;
  }
  modalContent.contentSet = true;
  return modalContent;
}
